import { LayoutPageDelivery } from "./layout/index";
import { RouterItemType } from "@/app/module/router/index";

export const routerPageDelivery: RouterItemType = {
  path: "/delivery",
  authorize: true,
  element: <LayoutPageDelivery />,
};
